import { render, staticRenderFns } from "./newYSPlayer.vue?vue&type=template&id=0ae5959e"
import script from "./newYSPlayer.vue?vue&type=script&lang=js"
export * from "./newYSPlayer.vue?vue&type=script&lang=js"
import style0 from "./newYSPlayer.vue?vue&type=style&index=0&id=0ae5959e&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports